export default "__VITE_ASSET__BQbYAzXk__"